<main class="carDetail">
  <h5 class="carDetail--title" *ngIf="!isDetail && isVip">
    {{ 'configCar' | i18next }}
  </h5>
  <h5 class="carDetail--title" *ngIf="isDetail">{{ 'orderData' | i18next }}</h5>
  <p class="carDetail--text" *ngIf="!isDetail && isVip">
    {{ 'configText' | i18next }}
  </p>
  <p *ngIf="isPhone && isVip" class="carDetail--text">
    {{ 'notPhoneMessage2' | i18next }}
  </p>
  <p *ngIf="isMacSafari || isIPad" class="carDetail--text">
    {{ 'notIPadMessage' | i18next }}
  </p>
  <p *ngIf="!isDetail && isVip" class="carDetail--text">
    {{ 'vipConfigText' | i18next }}
  </p>
  <form
    [formGroup]="form"
    ngClass="carDetail--formContainer"
    *ngIf="!summaryRequest && isVip"
  >
    <div class="form d-flex flex-wrap gap-0 align-items-stretch">
      <button
        *ngIf="!isVip"
        class="carDetail--formContainer__btn col-12 col-lg-6"
        mat-raised-button
        (click)="openLink('pcc')"
        type="button"
      >
        {{ 'requestPccConfig' | i18next | uppercase }}
      </button>
      <button
        *ngIf="isVip"
        class="carDetail--formContainer__btn col-12 col-lg-6"
        mat-raised-button
        (click)="openLink('seat')"
        type="button"
      >
        {{ 'seatConfig' | i18next }}
      </button>
      <button
        *ngIf="isVip"
        class="carDetail--formContainer__btn col-12 col-lg-6"
        mat-raised-button
        (click)="openLink('cupra')"
        type="button"
      >
        {{ 'cupraConfig' | i18next }}
      </button>
      <button
        *ngIf="!isVip"
        mat-raised-button
        class="carDetail--formContainer__btn form--showCarInfo__btn col-12 col-lg-6"
        [disabled]="disableShowVehicle"
        (click)="getVehicleInformation()"
        type="submit"
      >
        {{ 'requestPccShowVeicle' | i18next | uppercase }}
      </button>
    </div>

    <div class="form--showCarInfo">
      <div class="form--showCarInfo__input" *ngIf="showInput || isVip">
        <mat-form-field>
          <mat-label for="vehicleType">{{ 'pccCode' | i18next }}</mat-label>
          <input matInput type="text" formControlName="vehicleCode" />
        </mat-form-field>
      </div>
    </div>
    <button
      *ngIf="isVip"
      mat-raised-button
      class="carDetail--formContainer__btn form--showCarInfo__btn"
      (click)="getVehicleInformation()"
      type="submit"
    >
      {{ 'requestPccShowVeicle' | i18next }}
    </button>
    <p class="errorMsg" *ngIf="errorPcc">{{ errorPccText }}</p>
    <div class="text-center spinner-container" *ngIf="spinner">
      <div class="spinner-border spinner" role="status"></div>
    </div>
  </form>
  <section
    class="carDetail--info"
    *ngIf="vehicleInfoData && !errorPcc && !removeData"
  >
    <div class="carDetail--infoContainer">
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label col-12 col-sm-12 col-md-6">
          {{ 'requestPccMY' | i18next }}
        </p>
        <p class="text">{{ vehicleInfoData.modelYear }}</p>
      </div>
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
        *ngIf="isDetail"
      >
        <p class="label col-12 col-sm-12 col-md-6">
          {{ 'requestPccCountry' | i18next }}
        </p>
        <p class="text">{{ vehicleInfoData.nationalSalesPlan }}</p>
      </div>
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label lrow col-12 col-sm-12 col-md-6">
          {{ 'color' | i18next }}
        </p>
        <p class="text" *ngIf="!isDetail">{{ vehicleInfoData.descExtColor }}</p>
        <p class="text" *ngIf="isDetail">
          {{
            vehicleInfoData.exteriorColor?.description ||
              vehicleInfoData.extColor
          }}
        </p>
      </div>
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label lrow col-12 col-sm-12 col-md-6">
          {{ 'requestPccEmissions' | i18next }}
        </p>
        <p class="text">{{ vehicleInfoData.emissions }}</p>
      </div>
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label lrow col-12 col-sm-12 col-md-6">
          {{ 'requestPccTMAIMG' | i18next }}
        </p>
        <p class="text">
          {{ vehicleInfoData.tmaimg }}
        </p>
      </div>

      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
        *ngIf="extraData?.requestType !== requestTypeEnum.generalServices"
      >
        <p class="label col-12 col-sm-12 col-md-6">{{ 'price' | i18next }}</p>
        <p class="text" *ngIf="isDetail">
          {{ vehicleInfoData.prices.fee | numberData }} €
        </p>
        <p class="text" *ngIf="!isDetail">{{ quota | numberData }} €</p>
      </div>
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
        *ngIf="vehicle"
      >
        <p class="label lrow col-12 col-sm-12 col-md-6">
          {{ 'vinNumber' | i18next }}
        </p>
        <p class="text">
          {{ vehicle.VIN }}
        </p>
      </div>

      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label lrow col-12 col-sm-12 col-md-6">
          {{ 'model' | i18next }}
        </p>
        <p class="text">{{ vehicleInfoData.model }}</p>
      </div>
    </div>
    <div
      class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      *ngIf="isDetail"
    >
      <p class="label col-12 col-sm-12 col-md-6">
        {{ 'requestPccDescription' | i18next }}
      </p>
      <p class="text text-truncate" [title]="getFormattedDescriptions()">
        {{ getFormattedDescriptions() }}
      </p>
    </div>

    <div
      class="carDetail--infoContainer__grid d-flex flex-wrap gap-0 align-items-stretch"
      *ngIf="!isDetail"
    >
      <p class="label col-12 col-sm-12 col-md-6">
        {{ 'requestPccDescription' | i18next }}
      </p>
      <p class="text text-truncate" [title]="getPccFormattedDescriptions()">
        {{ getPccFormattedDescriptions() }}
      </p>
    </div>
    <div class="vehicleForm">
      <div class="column" *ngIf="!isDetail && !isVip">
        <div
          class="carDetail--infoContainer__grid d-flex flex-wrap gap-0 align-items-stretch"
        >
          <p class="label col-12 col-sm-12 col-md-6">
            {{ 'requestPccRemKind' | i18next }}
          </p>
          <p class="text">{{ vehicleInfoData.prices.secondRetribution }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="!isDetail && !isVip">
      <div
        class="carDetail--infoContainer__grid d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label col-12 col-sm-12 col-md-6">
          {{ 'requestPccNote' | i18next }}
        </p>
        <p class="text">
          {{ 'requestPccNoteText1' | i18next }}
          {{ 'requestPccNoteText2' | i18next }}
        </p>
      </div>
      <div
        class="carDetail--infoContainer__grid d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label col-12 col-sm-12 col-md-6">
          {{ 'requestPccPenalty' | i18next }}
        </p>
        <div class="text">
          <span class="bold">{{ 'requestPccPenaltyInc1' | i18next }}</span
          >{{ vehicleInfoData.prices.incrementB }}
          <span class="bold">{{ 'requestPccPenaltyInc2' | i18next }}</span
          >{{ vehicleInfoData.prices.incrementC }}
          <div>
            {{ 'requestPccPenaltyDesc' | i18next }}
          </div>
        </div>
      </div>
      <p class="carDetail--infoContainer__extra-info">
        {{ 'requestPccEndNote' | i18next }}
      </p>
    </div>
  </section>
  <section
    class="section vehicleSelectionSection"
    *ngIf="stockVehicleData && !errorPcc && !removeData"
  >
    <div class="carDetail--infoContainer">
      <div
        class="carDetail--infoContainer__row flex-wrap"
        *ngIf="!isModify && stockVehicleData.models"
      >
        <p class="label">
          {{ 'selectedModel' | i18next }}
        </p>
        <div class="carDetail--infoContainer__row">
          <ng-container
            *ngIf="
              stockVehicleData.models && stockVehicleData.models.length > 0;
              else noModel
            "
          >
            <p class="text">{{ getModelString(stockVehicleData.models) }}</p>
          </ng-container>
          <ng-template #noModel>
            <p class="text">{{ 'noData' | i18next }}</p>
          </ng-template>
        </div>
      </div>
      <div class="carDetail--infoContainer__row" *ngIf="stockVehicleData.VIN">
        <p class="label">
          {{ 'selectedVIN' | i18next }}
        </p>

        <div class="carDetail--infoContainer__row">
          <ng-container *ngIf="stockVehicleData.VIN; else noVIN">
            <div>
              <p class="text">{{ stockVehicleData.VIN }}</p>
            </div>
          </ng-container>
          <ng-template #noVIN>
            <p class="text">{{ 'noData' | i18next }}</p>
          </ng-template>
        </div>
      </div>
      <div
        class="carDetail--infoContainer__row"
        *ngIf="extraData.requestType === requestTypeEnum.loan"
      >
        <p class="label">
          {{ 'loanQuota' | i18next }}
        </p>
        <div class="carDetail--infoContainer__row">
          <ng-container *ngIf="loanData.loanQuota; else noQuota">
            <div>
              <p class="text">{{ loanData.loanQuota }}</p>
            </div>
          </ng-container>
          <ng-template #noQuota>
            <p class="text">{{ 'noData' | i18next }}</p>
          </ng-template>
        </div>
      </div>
    </div>
    <form [formGroup]="formModifyVehicle">
      <div
        class="carDetail--infoContainer__row"
        *ngIf="
          isModify &&
          stockVehicleData.models &&
          extraData.requestType !== requestTypeEnum.generalServices
        "
      >
        <mat-form-field>
          <mat-label required>{{ 'model' | i18next }}</mat-label>
          <mat-select formControlName="model">
            <mat-option
              *ngFor="let option of modelList"
              [value]="option.name"
              >{{ option.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="carDetail--infoContainer__row vehicleSelectionSection"
        *ngIf="
          isModify &&
          stockVehicleData &&
          extraData.requestType === requestTypeEnum.generalServices
        "
      >
        <h5 class="carConfig--vehicleType__title">
          {{ 'gsSelectStockModels' | i18next }}
        </h5>
        <div class="carConfig--vehicleType__checkboxContainer">
          <mat-checkbox
            color="primary"
            *ngFor="let model of modelList"
            [checked]="modelListSelected.includes(model.name)"
            (change)="changeModel(model.name)"
            >{{ model.name }}</mat-checkbox
          >
        </div>
      </div>
    </form>
    <button
      *ngIf="isModify && stockVehicleData.models"
      class="modify--btn"
      (click)="sendVehicleModify()"
      [disabled]="
        modelListSelected.length === 0 &&
        formModifyVehicle.get('model')?.value === ''
      "
      [ngStyle]="
        modelListSelected.length === 0 &&
        formModifyVehicle.get('model')?.value === ''
          ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
          : { 'background-color': '#c8f546' }
      "
    >
      {{ 'btnSave' | i18next | uppercase }}
    </button>
    <div *ngIf="loanData && !isModify">
      <div class="carDetail--infoContainer">
        <div class="carDetail--infoContainer__row">
          <p class="label">
            {{ 'reason' | i18next }}
          </p>

          <div class="carDetail--infoContainer__row">
            <ng-container *ngIf="loanData.reason; else noReason">
              <div>
                <p class="text">{{ loanData.reason }}</p>
              </div>
            </ng-container>
            <ng-template #noReason>
              <p class="text">{{ 'noData' | i18next }}</p>
            </ng-template>
          </div>
        </div>
        <div class="carDetail--infoContainer__row">
          <p class="label">
            {{ 'reasonText' | i18next }}
          </p>
          <div class="carDetail--infoContainer__row">
            <ng-container *ngIf="loanData.reason; else noReasonObs">
              <div>
                <p class="text">{{ loanData.reasonObservations }}</p>
              </div>
            </ng-container>
            <ng-template #noReasonObs>
              <p class="text">{{ 'noData' | i18next }}</p>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="carDetail--infoContainer">
        <div class="carDetail--infoContainer__row">
          <p class="label">
            {{ 'deliveryDate' | i18next }}
          </p>

          <div class="carDetail--infoContainer__row">
            <ng-container *ngIf="loanData.deliveryDateTime; else noDelivery">
              <div>
                <p class="text">
                  {{ loanData.deliveryDateTime | date: 'medium' }}
                </p>
              </div>
            </ng-container>
            <ng-template #noDelivery>
              <p class="text">{{ 'noData' | i18next }}</p>
            </ng-template>
          </div>
        </div>
        <div class="carDetail--infoContainer__row">
          <p class="label">
            {{ 'returnDate' | i18next }}
          </p>

          <div class="carDetail--infoContainer__row">
            <ng-container *ngIf="loanData.returnDateTime; else noReturn">
              <div>
                <p class="text">
                  {{ loanData.returnDateTime | date: 'medium' }}
                </p>
              </div>
            </ng-container>
            <ng-template #noReturn>
              <p class="text">{{ 'noData' | i18next }}</p>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="carDetail--infoContainer">
        <div class="carDetail--infoContainer__row">
          <p class="label">
            {{ 'loanCost' | i18next }}
          </p>
          <div class="carDetail--infoContainer__row">
            <div>
              <p class="text">{{ totalQuota }}</p>
            </div>
          </div>
        </div>
        <div class="carDetail--infoContainer__row">
          <p class="label">
            {{ 'loanDuration' | i18next }}
          </p>

          <div class="carDetail--infoContainer__row">
            <div>
              <p class="text">{{ totalDays }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="carDetail--infoContainer__row"
        *ngIf="loanData.loanType === 'CARPOOL'"
      >
        <p class="label">
          {{ 'center' | i18next }}
        </p>
        <div class="carDetail--infoContainer__row">
          <div>
            <p class="text">{{ loanData.carpoolCenter }}</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loanData && isModify">
      <form [formGroup]="formModify">
        <div class="carDetail--infoContainer">
          <div
            class="carDetail--infoContainer__row"
            *ngIf="loanData.loanType !== 'CARPOOL'"
          >
            <div class="carDetail--infoContainer__row">
              <mat-form-field class="width-standar">
                <mat-label class="loan-request--label" for="reason">{{
                  'reason' | i18next
                }}</mat-label>
                <mat-select
                  name="reason"
                  id="reason"
                  formControlName="reason"
                  class="loan-request--select__input"
                  (selectionChange)="changeReason($event.value)"
                >
                  <mat-option
                    *ngFor="let option of loanReasonsKeys"
                    [value]="option"
                  >
                    {{ loanReasonsEnum[option] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div
            class="carDetail--infoContainer__row"
            *ngIf="loanData.loanType === 'CARPOOL'"
          >
            <div class="carDetail--infoContainer__row">
              <mat-form-field class="width-standar">
                <mat-label class="loan-request--label" for="reason">{{
                  'reason' | i18next
                }}</mat-label>
                <mat-select
                  name="reason"
                  id="reason"
                  formControlName="reason"
                  class="loan-request--select__input"
                  (selectionChange)="changeReason($event.value)"
                >
                  <mat-option
                    *ngFor="let option of loanReasonsCPKeys"
                    [value]="option"
                  >
                    {{ loanReasonsCPEnum[option] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="carDetail--infoContainer__row">
            <mat-form-field class="custom-autocomplete">
              <mat-label>{{ 'loanReason' | i18next }}</mat-label>
              <textarea
                matInput
                name="reasonText"
                id="reasonText"
                class="loan-request--textArea"
                class="content--section__textarea--input"
                formControlName="reasonText"
              >
              </textarea>
            </mat-form-field>
          </div>
        </div>
        <div
          class="carDetail--infoContainer"
          *ngIf="loanData.loanType !== 'CARPOOL'"
        >
          <div class="carDetail--infoContainer__row">
            <div class="carDetail--infoContainer__row">
              <mat-form-field class="content--section__dateContainer">
                <mat-label>{{ 'deliveryDate' | i18next }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="deliveryPicker"
                  formControlName="deliveryDate"
                  (dateChange)="changeDate($event, 'deliveryDate')"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="deliveryPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #deliveryPicker
                  (closed)="close()"
                ></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="carDetail--infoContainer__row">
            <div class="carDetail--infoContainer__row">
              <mat-form-field class="content--section__dateContainer">
                <mat-label>{{ 'returnDate' | i18next }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="returnPicker"
                  formControlName="returnDate"
                  (dateChange)="changeDate($event, 'returnDate')"
                  [min]="formModify.value.deliveryDate"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="returnPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #returnPicker
                  (closed)="close()"
                ></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div
          class="carDetail--infoContainer"
          *ngIf="loanData.loanType === 'CARPOOL'"
        >
          <div class="carDetail--infoContainer__row">
            <p class="label">
              {{ 'deliveryDate' | i18next }}
            </p>

            <div class="carDetail--infoContainer__row">
              <ng-container *ngIf="loanData.deliveryDate; else noDelivery">
                <div>
                  <p class="text">{{ loanData.deliveryDate }}</p>
                </div>
              </ng-container>
              <ng-template #noDelivery>
                <p class="text">{{ 'noData' | i18next }}</p>
              </ng-template>
            </div>
          </div>
          <div class="carDetail--infoContainer__row">
            <p class="label">
              {{ 'returnDate' | i18next }}
            </p>

            <div class="carDetail--infoContainer__row">
              <ng-container *ngIf="loanData.returnDate; else noReturn">
                <div>
                  <p class="text">{{ loanData.returnDate }}</p>
                </div>
              </ng-container>
              <ng-template #noReturn>
                <p class="text">{{ 'noData' | i18next }}</p>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="carDetail--infoContainer">
          <div class="carDetail--infoContainer__row">
            <p class="label">
              {{ 'loanCost' | i18next }}
            </p>
            <div class="carDetail--infoContainer__row">
              <div>
                <p class="text">{{ totalQuota }}</p>
              </div>
            </div>
          </div>
          <div class="carDetail--infoContainer__row">
            <p class="label">
              {{ 'loanDuration' | i18next }}
            </p>

            <div class="carDetail--infoContainer__row">
              <div>
                <p class="text">{{ totalDays }}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="carDetail--infoContainer__row"
          *ngIf="loanData.loanType === 'CARPOOL'"
        >
          <div class="carDetail--infoContainer__row">
            <mat-form-field class="width-standar">
              <mat-label class="loan-request--label" for="carpoolCenter">{{
                'center' | i18next
              }}</mat-label>
              <mat-select
                name="carpoolCenter"
                id="carpoolCenter"
                formControlName="carpoolCenter"
                class="loan-request--select__input"
              >
                <mat-option value="SEAT_COMPONENTES">
                  {{ 'centerSeat' | i18next }}
                </mat-option>
                <mat-option value="ZONA_FRANCA">
                  {{ 'centerZone' | i18next }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <button
          class="modify--btn"
          (click)="sendLoanModify()"
          [disabled]="formModify.invalid"
          [ngStyle]="
            formModify.invalid
              ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
              : { 'background-color': '#c8f546' }
          "
        >
          {{ 'btnSave' | i18next | uppercase }}
        </button>
      </form>
    </div>
  </section>

  <section class="carDetail--info" *ngIf="educationalData">
    <div class="carDetail--infoContainer">
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label col-12 col-sm-12 col-md-6">
          {{ 'fuel' | i18next }}
        </p>
        <p class="text">{{ educationalData.fuelType }}</p>
      </div>
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label col-12 col-sm-12 col-md-6">
          {{ 'reason' | i18next }}
        </p>
        <p class="text">{{ educationalData.reason }}</p>
      </div>
      <div
        class="carDetail--infoContainer__row d-flex flex-wrap gap-0 align-items-stretch"
      >
        <p class="label lrow col-12 col-sm-12 col-md-6">
          {{ 'specifications' | i18next }}
        </p>
        <p class="text">
          {{ educationalData.specifications }}
        </p>
      </div>
    </div>
  </section>

  <section
    class="section"
    *ngIf="
      !vehicleInfoData && !stockVehicleData && !educationalData && isDetail
    "
  >
    <p>{{ 'noDataAvailable' | i18next }}</p>
  </section>
</main>
<div class="iframe-container" *ngIf="!isVip && !isDetail">
  <iframe
    [src]="pcc"
    frameborder="0"
    style="width: 100%; height: 100vh"
    allowfullscreen
    [ngStyle]="
      vehicleType === requestTypeEnum.leasing
        ? { zoom: '0.9' }
        : { zoom: '1.0' }
    "
  >
  </iframe>
</div>
